module.exports = __webpack_public_path__ + "images/fernando_martinelli.jpg?v=d62cc7096fe4cf11207d27f58a85cfd5";